export default __webpack_public_path__ + "static/media/brain-hq-logo.f5c12736.png";